import React from 'react';
import { Map, Satellite, Layers } from 'lucide-react';
import { TerritorySelector } from './TerritorySelector';
import type { FUNAITerritoryEntry } from '../types';
import './Header.css';

type ViewMode = 'map' | 'satellite';

interface HeaderProps {
  totalCells: number;
  avgBQI: number;
  viewMode?: ViewMode;
  onViewModeChange?: (mode: ViewMode) => void;
  selectedTerritories?: FUNAITerritoryEntry[];
  onTerritorySelect?: (territories: FUNAITerritoryEntry[]) => void;
  isTerritoryLoading?: boolean;
  showBoundary?: boolean;
  onToggleBoundary?: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  totalCells: _totalCells,
  avgBQI: _avgBQI,
  viewMode = 'map',
  onViewModeChange,
  selectedTerritories = [],
  onTerritorySelect,
  isTerritoryLoading = false,
  showBoundary = true,
  onToggleBoundary
}) => {
  // Get subtitle based on selected territories
  const getSubtitle = () => {
    if (selectedTerritories.length === 0) {
      return 'Arariboia Indigenous Reserve, Brazil';
    }
    if (selectedTerritories.length === 1) {
      return `${selectedTerritories[0].name}, Brazil`;
    }
    return `${selectedTerritories.length} territories selected, Brazil`;
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <img
            src="/assets/67e576613965889055c144c4_092eeed2574624df261cb0d29a2157e8_GPC_Logo_long_v2503051933_white.svg"
            alt="GPC International"
            className="header-logo"
          />
          <div className="header-divider" />
          <div className="header-title-group">
            <h1 className="header-title">Biodiversity Management</h1>
            <p className="header-subtitle">{getSubtitle()}</p>
          </div>
        </div>

        {onTerritorySelect && (
          <TerritorySelector
            selectedTerritories={selectedTerritories}
            onTerritorySelect={onTerritorySelect}
            isLoading={isTerritoryLoading}
          />
        )}

        <div className="header-nav">
          {onToggleBoundary && viewMode === 'map' && (
            <button
              className={`nav-button ${showBoundary ? 'nav-button-active' : ''}`}
              onClick={onToggleBoundary}
            >
              <Layers size={16} />
              Boundaries
            </button>
          )}
          {onViewModeChange && (
            <>
              <button
                className={`nav-button ${viewMode === 'map' ? 'nav-button-active' : ''}`}
                onClick={() => onViewModeChange('map')}
              >
                <Map size={16} />
                Map View
              </button>
              <button
                className={`nav-button ${viewMode === 'satellite' ? 'nav-button-active' : ''}`}
                onClick={() => onViewModeChange('satellite')}
              >
                <Satellite size={16} />
                Snapshot Browser
              </button>
            </>
          )}
        </div>

      </div>
    </header>
  );
};
